import { Routes } from '@angular/router';
import { FormComponent } from 'src/app/pages/form/form.component';
import { ErrorComponent } from 'src/app/ui/templates/error/error.component';
import { PaymentStatusComponent } from 'src/app/pages/payment-status/payment-status.component';

export const ROUTE_PATHS = {
  FORM: '',
  CHECK_STATUS: 'checkStatus',
}

export const routes: Routes = [
  { path: ROUTE_PATHS.FORM, component: FormComponent },
  { path: ROUTE_PATHS.CHECK_STATUS, component: PaymentStatusComponent },
  { path: '**', component: ErrorComponent }
];
